import React from 'react'
import { navigate } from "gatsby";
import * as BS from "react-bootstrap";

function BreadHome() {

    const doThis = () => {
        navigate("https://www.startupmag.co.uk")
      }

      
    return (
       <>
       <BS.Breadcrumb.Item onClick={doThis}> Home</BS.Breadcrumb.Item>
       </>
    )
}

export default BreadHome
